import { statisticsWindow, type StatisticsPeriod } from './statistics'

export type PinduoduoStatisticsPeriod = StatisticsPeriod | 'previous2Month' | 'custom'
export interface PinduoduoCustomRange { startDate: string; endDate: string }
export interface PinduoduoStatisticsWindow {
  key: PinduoduoStatisticsPeriod
  label: string
  startDate: string
  endDate: string
  dates: string[]
  requestedDayCount: number
  complete: boolean
  dataStartDate: string
  dataEndDate: string
}

const calendarDates = (startDate: string, endDate: string) => {
  const dates: string[] = []
  const cursor = new Date(`${startDate}T00:00:00Z`)
  const end = new Date(`${endDate}T00:00:00Z`)
  while (cursor <= end) {
    dates.push(cursor.toISOString().slice(0, 10))
    cursor.setUTCDate(cursor.getUTCDate() + 1)
  }
  return dates
}

export function pinduoduoStatisticsWindow(
  facts: { meta: { queryStart: string; queryEnd: string } } | null,
  period: PinduoduoStatisticsPeriod,
  customRange: PinduoduoCustomRange = { startDate: '', endDate: '' },
): PinduoduoStatisticsWindow | null {
  if (!facts) return null
  const availableDates = calendarDates(facts.meta.queryStart, facts.meta.queryEnd)
  if (period !== 'previous2Month' && period !== 'custom') return {
    ...statisticsWindow(period, facts.meta.queryEnd, availableDates),
    dataStartDate: facts.meta.queryStart,
    dataEndDate: facts.meta.queryEnd,
  }
  let startDate = facts.meta.queryStart
  let endDate = facts.meta.queryEnd
  if (period === 'previous2Month') {
    const targetMonth = new Date(`${facts.meta.queryEnd.slice(0, 7)}-01T00:00:00Z`)
    targetMonth.setUTCMonth(targetMonth.getUTCMonth() - 2)
    startDate = targetMonth.toISOString().slice(0, 10)
    const targetMonthEnd = new Date(targetMonth)
    targetMonthEnd.setUTCMonth(targetMonthEnd.getUTCMonth() + 1)
    targetMonthEnd.setUTCDate(0)
    endDate = targetMonthEnd.toISOString().slice(0, 10)
  } else {
    startDate = customRange.startDate || facts.meta.queryStart
    endDate = customRange.endDate || facts.meta.queryEnd
    startDate = startDate < facts.meta.queryStart ? facts.meta.queryStart : startDate > facts.meta.queryEnd ? facts.meta.queryEnd : startDate
    endDate = endDate < facts.meta.queryStart ? facts.meta.queryStart : endDate > facts.meta.queryEnd ? facts.meta.queryEnd : endDate
    if (startDate > endDate) [startDate, endDate] = [endDate, startDate]
  }
  const dates = availableDates.filter((date) => date >= startDate && date <= endDate)
  const requestedDayCount = Math.round((new Date(`${endDate}T00:00:00Z`).getTime() - new Date(`${startDate}T00:00:00Z`).getTime()) / 86400000) + 1
  return {
    key: period,
    label: period === 'custom' ? '自定义' : '上上月',
    startDate,
    endDate,
    dates,
    requestedDayCount,
    complete: dates.length === requestedDayCount,
    dataStartDate: facts.meta.queryStart,
    dataEndDate: facts.meta.queryEnd,
  }
}

export function pinduoduoStatisticsSearch(period: PinduoduoStatisticsPeriod, customRange: PinduoduoCustomRange) {
  const params = new URLSearchParams({ period })
  if (period === 'custom') {
    if (customRange.startDate) params.set('start', customRange.startDate)
    if (customRange.endDate) params.set('end', customRange.endDate)
  }
  return `?${params.toString()}`
}
